import classNames from 'classnames'
import { capitalizeFirstLetter } from 'shared/utils'

import styles from '../styles/icon-href.module.scss'

const IconHref = ({ isActive = false, alt, iconPath, iconActivePath, url }) => {
    const title = capitalizeFirstLetter(alt)
    const btnClass = classNames(!isActive && styles.navIconButton, isActive && styles.navIconButtonActive)
    return (
        <a title={title} href={url} target="__blank" className={btnClass}>
            <div>
                <img alt={alt} src={iconPath} />
                <img alt={alt} src={iconActivePath} />
            </div>
        </a>
    )
}

IconHref.propTypes = {
    isActive: PropTypes.bool,

    alt: PropTypes.string.isRequired,
    iconPath: PropTypes.string.isRequired,
    iconActivePath: PropTypes.string.isRequired,

    url: PropTypes.string.isRequired,
}

export default IconHref
